import { render } from "./App.vue?vue&type=template&id=5057711d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5057711d&lang=css"
import "./App.vue?vue&type=style&index=1&id=5057711d&lang=scss&scoped=true"

import exportComponent from "/Users/luguoguo999lu/Desktop/work/randou/code/internal-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5057711d"]])

export default __exports__